import React from 'react';
import PropTypes from 'prop-types';
import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material';

const CurrencyToggle = ({ currency, onCurrencyChange, currencies }) => {
  const selectedIndex = Object.keys(currencies).indexOf(currency);

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 4 }}>
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          gap: 0,
          p: 0.75,
          borderRadius: 9999,
          bgcolor: '#f2f4f7',
          boxShadow: 'inset 0 1px 0 rgba(0,0,0,0.04)',
          width: 320,
          maxWidth: '90vw',
        }}
      >
        {/* Sliding dark rectangle */}
        <Box
          aria-hidden
          sx={{
            position: 'absolute',
            top: 6,
            left: 6,
            height: 44,
            width: 'calc((100% - 12px - 16px) / 3)',
            borderRadius: 10,
            bgcolor: '#0f172a',
            transition: 'transform 260ms cubic-bezier(0.22, 1, 0.36, 1)',
            transform: `translateX(calc(${selectedIndex * 100}% + ${selectedIndex * 8}px))`,
            boxShadow: '0 2px 8px rgba(15,23,42,0.2)',
            overflow: 'hidden',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              borderRadius: 10,
              background: 'radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)',
              opacity: 0,
              transition: 'opacity 0.3s ease',
              pointerEvents: 'none',
            },
            '&:active::before': {
              opacity: 1,
            },
          }}
        />

        <ToggleButtonGroup
          value={currency}
          exclusive
          onChange={onCurrencyChange}
          aria-label="currency selection"
          sx={{
            position: 'relative',
            width: '100%',
            zIndex: 1,
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: 1,
            '& .MuiToggleButton-root': {
              border: 0,
              borderRadius: 10,
              color: '#64748b',
              fontWeight: 600,
              letterSpacing: 0.25,
              px: 2,
              py: 1.25,
              transition: 'background-color 160ms ease, color 160ms ease',
              overflow: 'hidden',
              '&:hover': {
                backgroundColor: '#ffffffc5',
              },
              '&.Mui-selected': {
                color: '#ffffff',
                backgroundColor: 'transparent',
              },
              '&.Mui-selected:hover': {
                backgroundColor: 'transparent',
              },
            },
          }}
        >
          {Object.keys(currencies).map((currencyKey) => (
            <ToggleButton key={currencyKey} value={currencyKey} aria-label={currencyKey}>
              {currencyKey.toUpperCase()}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </Box>
    </Box>
  );
};

CurrencyToggle.propTypes = {
  currency: PropTypes.string.isRequired,
  onCurrencyChange: PropTypes.func.isRequired,
  currencies: PropTypes.object.isRequired,
};

export default CurrencyToggle;
